export function parseURL(content){
    let str_content = "";
    if(typeof content != "string"){
        str_content = [...content].join("");
    }
    else{
        str_content = content;
    }
    let ret = [];
    let retStr = "";
    let currentURL = "";
    let command = "";
    str_content.split("").forEach((char)=>{
        if(char == "["){
            command = "[";
        }
        else if(char == "]"){
            command += "]";
            if(command.startsWith("[url=")){
                ret.push(m("span",retStr));
                currentURL=command.slice(5, command.length-1);
                retStr = "";
            }else if(command == "[/url]"){
                ret.push(m("a",{href: currentURL},retStr));
                retStr ="";
            }else{
                retStr += command;
            }
            command = "";
        }else if(command == ""){
            retStr += char;
        }else{
            command += char;
        }
    });
    ret.push(m("span",retStr));
    return ret;
}